import React from 'react';
import ReactDatatable from '@ashvin27/react-datatable';
import axios from 'axios';
import { Card, CardBody, Col } from 'reactstrap';
import { baseURL } from '../../_helpers';
import Select from "react-select";

export class DailyBetsChannel extends React.Component {
    constructor(props) {
        super(props);


        this.columns = [
            {
                key: "Bets_date",
                TrOnlyClassName: 'tsc',
                text: "DATE",
                className: "tsc",
                align: "left"
            },
            {
                key: "Customer",
                TrOnlyClassName: 'tsc',
                text: "Customer",
                className: "tsc",
                align: "left"
            },
            {
                key: "Bets",
                TrOnlyClassName: 'tsc',
                text: "Bets",
                className: "tsc",
                align: "left"
            },
            {
                key: "Channel",
                TrOnlyClassName: 'tsc',
                text: "Channel",
                className: "tsc",
                align: "left"
            },

        ];
        this.config = {
            key_column: "tsc",
            length_menu: [10, 20, 50],
            show_filter: true,
            show_pagination: true,
            pagination: 'advance',
            page_size: 10,
            show_length_menu: true,
            button: {
                excel: true,
                print: true,
                csv: true,
            },
            language: {
                loading_text: "Please be patient while data loads...",
                filter: "Enter date (YYYY-MM-DD)",
                no_data_text: "No data was found",
                pagination: {
                    next: <span>&#9658;</span>,
                    previous: <span>&#9668;</span>
                    // next
                    // previous
                }
            }
        }
        this.state = {
            admins: [],
            isLoading: true,
            showModal: false,
            showError: false,
            isShowError: false,
            showComponent: false,
            hideComponent: false,
            data: [],
            terms_channel: [
                {
                    label: 'Movitel',
                    value: 'Movitel',
                },
                {
                    label: 'Vodacom',
                    value: "Vodacom"
                }
            ],
            channel: 'Vodacom'
        };
    }
    handleChangeChannel = value => {
        if (value != null) {
            this.setState(
                {
                    channel: value.value,
                });
        }
        else {
            this.setState(
                {
                    channel: "Vodacom",
                });

        }
        this.getData(this.state.channel);

    }

    componentDidMount() {
        this.getData(this.state.channel);
    }
    getData = (channel, queryString = "") => {
        this.setState({
            isLoading: true,
        })
        let url = baseURL + "getBetChannel?channel=" + channel + "&&" + queryString
        console.log("query", url);

        axios.all([
            axios.get(url),
        ]).then(axios.spread((branchResponse) => {
            this.setState({
                admins: branchResponse.data,
                isLoading: false,
            },
                function () {

                    var data = [];
                    console.log("BUG", this.state.admins)

                    if (this.state.admins.length > 0) {


                        for (let i = 0; i < this.state.admins.length; i++) {
                            this.setState({
                                total: this.state.admins[0].total_page
                            })

                            // let paystack = { Hours: this.state.admins[i].hours.toString() }

                            data.push(Object.assign(this.state.admins[i]));

                            this.setState({
                                data: data,
                                isLoading: false
                            })
                            console.log("bugs", i);




                        }




                    } else {

                        this.setState({
                            data: data,
                            isLoading: false
                        })
                        console.log("bugs", data);

                    }


                }
            );
        }))

    }

    tableChangeHandler = data => {
        let queryString = Object.keys(data).map((key) => {
            if (key === "sort_order" && data[key]) {
                return encodeURIComponent("sort_order") + '=' + encodeURIComponent(data[key].order) + '&' + encodeURIComponent("sort_column") + '=' + encodeURIComponent(data[key].column)
            } else {
                return encodeURIComponent(key) + '=' + encodeURIComponent(data[key])
            }

        }).join('&');

        this.getData(this.state.channel, queryString);
    }

    render() {
        return (
            <div>
                <>
                    <Col md={12}>
                        <h3>Daily Bets</h3><br />

                    </Col>
                    < Col md={12} lg={12} >
                        < Card >
                            <CardBody >
                                <div className="panel-body" >


                                    {this.state.isShowError ?
                                        <div className="alert alert-success" > {this.state.statusMessage}
                                        </div> : null
                                    }
                                    <br />
                                    <div className="col-md-4">
                                        <Select
                                            isClearable
                                            options={this.state.terms_channel}
                                            placeholder="Select Target Default Vodacom"
                                            autosize={true}
                                            onChange={this.handleChangeChannel}
                                            className="selected"
                                            menuPortalTarget={document.body}
                                            name="namffe"
                                        />
                                        <br />
                                    </div>
                                    <br />

                                    <ReactDatatable
                                        config={this.config}
                                        records={this.state.data}
                                        columns={this.columns}
                                        dynamic={true}
                                        id="tsc"
                                        loading={this.state.isLoading}
                                        total_record={this.state.total}
                                        onChange={this.tableChangeHandler} /></div>
                            </CardBody>
                        </Card>
                    </Col>
                </>
            </div>
        )
    }
}